<ng-template #template>
  <div
    class="card-spacing"
    [ngClass]="[
      'col-lg-' + width,
      needpaddingLeft ? 'pr-lg-0' : 'p-lg-0',
      isZoom ? 'zoomed' : ''
    ]"
  >
    <div class="card h-100">
      <div class="card-body">
        <h2>{{ data?.title }}</h2>
        <a
          (click)="zoom()"
          class="zoom"
          *ngIf="data.zoomInfo"
          [attr.aria-label]="'Zoom ' + data?.title"
          href="javascript:void(0)"
          ><img src="img/magnifier.svg" width="20px" class="zoom-chart"
        /></a>
        <div
          style="
            width: 75%;
            height: 75%;
            text-align: center;
            margin: auto;
            margin-top: 10%;
          "
        >
          <div>
            <canvas
              [attr.displayText]="chartData.text"
              [attr.rgbColor]="chartData.rgbColor"
              baseChart
              [data]="chartData.chartData"
              [labels]="chartLabels"
              [options]="chartOptions"
              [colors]="colors"
              [plugins]="doughnutChartPlugins"
              [chartType]="chartType"
            >
            </canvas>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
